import axios from 'axios';
import AuthService from '../../../olsStateManagement/services/auth.service';
import {
  IS_PRODUCTION_ENVIRONMENT,
  LOCALHOST_API_URL,
  DEVELOPMENT_API_URL
  } from '../../../olsStateManagement/helpers/constants';

  const authService = new AuthService();

// API URL
if (IS_PRODUCTION_ENVIRONMENT) {
axios.defaults.baseURL = LOCALHOST_API_URL
}else {
axios.defaults.baseURL = DEVELOPMENT_API_URL;
}

// GET ACCESS TOKEN AND SET AUTHORIZATION HEADER WITH BEARER TOKEN SO WE'RE ABLE TO AUTHENTICATE WITH OLS API
const authorizationHeader = 'Authorization'
axios.defaults.headers.locale = authService.getLocaleFromUrl();

axios.defaults.headers.common[authorizationHeader] = 'Bearer ' + authService.getAccessToken();
